/**
 * AI Translate Button Handler
 * Handles the global AI translation button in the admin header.
 */

document.addEventListener('DOMContentLoaded', function() {
    const btn = document.getElementById('ai-translate-btn');

    if (!btn) return;

    btn.addEventListener('click', async function() {
        if (btn.disabled) return;

        const modelClass = btn.dataset.modelClass;
        const modelId = btn.dataset.modelId;
        const language = btn.dataset.language;

        // Get language name for display
        const languageNames = {
            'nl': 'Nederlands',
            'en': 'Engels',
            'de': 'Duits',
            'fr': 'Frans',
            'es': 'Spaans',
            'it': 'Italiaans',
        };
        const languageName = languageNames[language] || language.toUpperCase();

        // Show confirmation dialog (same message as canvas translate)
        const confirmed = await Swal.fire({
            title: 'AI Vertaling',
            html: `<div class="text-left text-sm">
                <p class="mb-3">Deze functie vertaalt alle teksten naar <strong>${languageName}</strong>, alle teksten die al in deze taal zijn worden niet aangepast.</p>
                <p class="mb-3">Als er woorden uit een andere taal gebruikt zijn in deze tekst kan dat wel invloed hebben of dit wordt aangepast of niet.</p>
                <p class="mb-0 text-gray-600">Dus voor de zekerheid kan je eerst alles 'Live plaatsen' (en eventueel de pagina offline zetten) en dan kan je altijd de wijzigingen nog terugdraaien naar de vorige versie.</p>
            </div>`,
            icon: 'info',
            showCancelButton: true,
            confirmButtonText: 'Ja, vertalen',
            confirmButtonColor: '#6366f1',
            cancelButtonText: 'Annuleren',
        });

        if (!confirmed.value) return;

        // Show full page overlay
        showLoadingOverlay();

        try {
            const response = await axios.post('/admin/translate-model', {
                model_class: modelClass,
                model_id: modelId,
                language: language,
            });

            if (response.data.success) {
                hideLoadingOverlay();

                await Swal.fire({
                    title: 'Vertaling voltooid',
                    text: `${response.data.translatedCount} item(s) vertaald naar ${languageName}!`,
                    icon: 'success',
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#6366f1',
                });

                // Reload page to show changes
                window.location.reload();
            } else {
                throw new Error(response.data.error || 'Unknown error');
            }

        } catch (error) {
            hideLoadingOverlay();

            console.error('Translation error:', error);

            Swal.fire({
                title: 'Fout bij vertalen',
                text: 'Er is een fout opgetreden bij het vertalen. Probeer het later opnieuw.',
                icon: 'error',
                confirmButtonText: 'Sluiten',
                confirmButtonColor: '#6366f1',
            });
        }
    });
});

function showLoadingOverlay() {
    // Create overlay element
    const overlay = document.createElement('div');
    overlay.id = 'ai-translate-overlay';
    overlay.innerHTML = `
        <div class="fixed inset-0 bg-gray-900 bg-opacity-75 flex items-center justify-center z-[9999]">
            <div class="bg-white rounded-lg p-8 flex flex-col items-center shadow-2xl">
                <div class="animate-spin rounded-full h-16 w-16 border-4 border-indigo-500 border-t-transparent mb-4"></div>
                <h3 class="text-xl font-semibold text-gray-800 mb-2">Bezig met vertalen...</h3>
                <p class="text-gray-500">Dit kan enkele momenten duren</p>
            </div>
        </div>
    `;
    document.body.appendChild(overlay);
}

function hideLoadingOverlay() {
    const overlay = document.getElementById('ai-translate-overlay');
    if (overlay) {
        overlay.remove();
    }
}
